import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import AutosizeInput from 'react-input-autosize';
import { styled } from 'styled-components';
import Icons from '../../Elements/Icons/index.js';
const IconsEdit = styled(Icons.Edit) `
  cursor: pointer;
`;
const Wrapper = styled.div `
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-right: 26px;
  align-self: flex-start;
  input {
    font-size: 22px;
    line-height: 26px;
    border-width: 0 0 1px 0;
    border-style: solid;
    background: none;
    color: ${({ theme }) => theme.colors.black_1};
    padding: 0 0 1px 0;
    outline: none;
    &[readonly] {
      border-color: transparent;
    }
  }
`;
const EditableTitle = (props) => {
    const { className = '', input, meta: _meta, ...other } = props;
    const inputField = React.useRef(null);
    const [readonly, setReadonly] = React.useState(true);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const focusInputField = React.useCallback(() => {
        setReadonly(false);
        inputField.current?.focus();
    }, [inputField, setReadonly]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onBlur = React.useCallback(() => {
        setReadonly(true);
    }, [setReadonly]);
    return (_jsxs(Wrapper, { "data-testid": 'placement-name-field', children: [_jsx(AutosizeInput, { className: className, 
                // @ts-expect-error issue with AutosizeInput types - expected ref like string
                ref: inputField, ...input, onBlur: onBlur, readOnly: readonly, ...other }), readonly && _jsx(IconsEdit, { size: 26, onClick: focusInputField })] }));
};
export default EditableTitle;
